export interface ActionField {
  name: string;
  label: string;
  type: 'string' | 'number' | 'array' | 'select' | 'textarea' | 'fields-list' | 'potential-actions-list';
  placeholder?: string;
  isRequired?: boolean;
  defaultValue?: any;
  options?: { title: string; value: string }[];
}

export interface ActionDefinition {
  type: string; // Internal Enum name (e.g. SEND_SLACK_WEBHOOK)
  aliases?: string[]; // Documentation names or Red Canary exec/actions strings
  label: string;
  fields: ActionField[];
}

export const SUPPORTED_ACTIONS: ActionDefinition[] = [
  {
    type: 'SEND_SLACK_WEBHOOK',
    aliases: ['SendSlackWebhook', 'exec/actions/send_slack_webhook'],
    label: 'Send Slack Message',
    fields: [
      { name: 'title', label: 'Message Title', type: 'string', isRequired: true, placeholder: 'Critical alert from CrowdStrike' },
      { name: 'author_name', label: 'Author Name', type: 'string', isRequired: true, placeholder: 'Security Platform' },
      { name: 'channel', label: 'Channels', type: 'string', isRequired: true, placeholder: '#security-alerts' },
      { name: 'color', label: 'Color (Hex)', type: 'string', placeholder: 'e.g. #FF0000' },
      { name: 'icon_url', label: 'Icon URL', type: 'string', placeholder: 'https://example.com/icon.png' },
      { name: 'title_link', label: 'Title Link', type: 'string', placeholder: 'https://portal.example.com' },
      { name: 'fields', label: 'Custom Fields', type: 'fields-list' },
    ],
  },
  {
    type: 'SEND_EMAIL',
    aliases: ['SendMail', 'exec/actions/send_mail'],
    label: 'Send Email',
    fields: [
      { name: 'to', label: 'To', type: 'string', isRequired: true, placeholder: 'recipient@example.com' },
      { name: 'subject', label: 'Subject', type: 'string', isRequired: true, placeholder: 'Security Alert' },
      { name: 'body', label: 'Body', type: 'textarea', isRequired: true, placeholder: 'Incident details...' },
      { name: 'cc', label: 'CC', type: 'string', placeholder: 'manager@example.com' },
      { name: 'bcc', label: 'BCC', type: 'string', placeholder: 'audit@example.com' },
      { name: 'reply_to', label: 'Reply To', type: 'string', placeholder: 'soc@example.com' },
    ],
  },
  {
    type: 'RC_SEND_SMS_MESSAGE',
    aliases: ['SendSMSMessage', 'exec/actions/send_sms_message'],
    label: 'Send SMS',
    fields: [
      { name: 'phone_numbers', label: 'Phone Numbers', type: 'string', isRequired: true, placeholder: '+15551234567' },
      { name: 'message', label: 'Message', type: 'string', isRequired: true, placeholder: 'Security alert notification' },
    ],
  },
  {
    type: 'RC_BAN_FILE_HASHES',
    aliases: ['RCBanFileHashes', 'exec/actions/ban_hashes'],
    label: 'Ban File Hashes',
    fields: [{ name: 'hashes', label: 'Hashes (JSON Array)', type: 'textarea', isRequired: true, placeholder: '["hash1", "hash2"]' }],
  },
];
